import { render, staticRenderFns } from "./eqadmissionExamination.vue?vue&type=template&id=4fdda7c0&scoped=true"
import script from "./eqadmissionExamination.vue?vue&type=script&lang=js"
export * from "./eqadmissionExamination.vue?vue&type=script&lang=js"
import style0 from "./eqadmissionExamination.vue?vue&type=style&index=0&id=4fdda7c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdda7c0",
  null
  
)

export default component.exports